import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CalendarService } from 'src/app/services/calender-service';
import {
  CalenderNameViewModel,
  DatePickerModel,
  DayDatePickerModel,
  MonthViewModel,
  PersianDateViewModel,
  WeekViewModel,
} from '../../../models/calender-models/calender-model';
import { DatePipe } from '@angular/common';
import { MonthDays } from 'src/app/models/new-calender-models/month-days';
import { NewCalendarService } from 'src/app/services/new-calender-service';
import { WeekDayName } from 'src/app/models/new-calender-models/week-day-name';
import { YearItem } from 'src/app/models/new-calender-models/year-item';
import { MonthItem } from 'src/app/models/new-calender-models/month-item';
import { SelectDay } from 'src/app/models/new-calender-models/select-day';
import { DayItem } from 'src/app/models/new-calender-models/day-item';

@Component({
  selector: 'app-data-picker',
  templateUrl: './data-picker.component.html',
  styleUrls: ['./data-picker.component.css'],
})
export class DataPickerComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    public datepipe: DatePipe,
    private calendarService: NewCalendarService
  ) {
    this.weekName = this.calendarService.getWeekDayName(this.calenderIsJalali);

    this.thisMonth = this.calendarService.getToDayMonthJalali();
    this.selectedYear = this.thisMonth.year;
    this.selectedMonth = this.thisMonth.monthNumber;
    if (this.thisMonth.specificDay == null) {
      this.thisMonth.specificDay = 1;
    }
    this.todayJalali = new SelectDay(
      this.thisMonth.year,
      this.thisMonth.monthNumber,
      this.thisMonth.specificDay,
      '',
      ''
    );

    const thisMonthGregorian = this.calendarService.getToDayMonthGregorian();
    if (thisMonthGregorian.specificDay == null) {
      thisMonthGregorian.specificDay = 1;
    }
    this.todayGregorian = new SelectDay(
      thisMonthGregorian.year,
      thisMonthGregorian.monthNumber,
      thisMonthGregorian.specificDay,
      '',
      ''
    );

    this.thisYears = this.calendarService.getYear(
      this.yearPage,
      this.calenderIsJalali
    );
    this.months = this.calendarService.getMonth(this.calenderIsJalali);

    this.isRtl = false;
  }

  @Output() childPropChange = new EventEmitter<string>();
  @Output() changeVariableMonth = new EventEmitter<string>();
  @Input() childProp?: string;

  public todayJalali: SelectDay;
  public todayGregorian: SelectDay;
  public thisMonth: MonthDays;
  public thisYears: YearItem[];
  public months: MonthItem[];
  public weekName: WeekDayName[];
  public level: number = 0;
  public yearPage: number = 0;

  public selectedYear: number;
  public selectedMonth: number;
  public calenderIsJalali: boolean = true;

  public isRtl: boolean;

  public GotoDay() {
    if (this.calenderIsJalali) {
      this.thisMonth = this.calendarService.getToDayMonthJalali();
    } else {
      this.thisMonth = this.calendarService.getToDayMonthGregorian();
    }
    this.selectedYear = this.thisMonth.year;
    this.selectedMonth = this.thisMonth.monthNumber;
  }

  public ngOnInit(): void {
    var thisCulture = this.translate.currentLang;

    if (thisCulture == 'fa') {
      this.isRtl = true;
    } else {
      this.isRtl = false;
    }
  }

  public nextMonth() {
    if (this.thisMonth.monthNumber == 12) {
      this.selectedMonth = 1;
      this.selectedYear++;
    } else {
      this.selectedMonth++;
    }
    this.thisMonth = this.calendarService.getMonthDays(
      this.selectedMonth,
      this.selectedYear,
      this.calenderIsJalali
    );
  }

  public previousMonth() {
    if (this.thisMonth.monthNumber == 1) {
      this.selectedYear--;
      this.selectedMonth = 12;
    } else {
      this.selectedMonth--;
    }
    this.thisMonth = this.calendarService.getMonthDays(
      this.selectedMonth,
      this.selectedYear,
      this.calenderIsJalali
    );
  }

  public nextYearPage() {
    this.yearPage++;
    this.thisYears = this.calendarService.getYear(
      this.yearPage,
      this.calenderIsJalali
    );
  }

  public previousYearPage() {
    this.yearPage--;
    this.thisYears = this.calendarService.getYear(
      this.yearPage,
      this.calenderIsJalali
    );
  }

  public selectYear(year: number) {
    this.selectedYear = year;
    this.level = 2;
  }

  public selectMonth(month: number) {
    this.selectedMonth = month;
    this.level = 0;
    this.thisMonth = this.calendarService.getMonthDays(
      this.selectedMonth,
      this.selectedYear,
      this.calenderIsJalali
    );
  }

  public ToJalali() {
    this.calenderIsJalali = true;
    
    this.thisMonth = this.calendarService.ConvertToJalali(
      this.thisMonth.monthNumber,
      this.thisMonth.year
    );

    this.refreshCalender();
  }

  public ToGregorian() {
    this.calenderIsJalali = false;

    this.thisMonth = this.calendarService.ConvertToGregorian(
      this.thisMonth.monthNumber,
      this.thisMonth.year
    );
    this.refreshCalender();
  }

  public refreshCalender() {
    this.weekName = this.calendarService.getWeekDayName(this.calenderIsJalali);
    this.thisYears = this.calendarService.getYear(
      this.yearPage,
      this.calenderIsJalali
    );
    this.months = this.calendarService.getMonth(this.calenderIsJalali);
    this.selectedYear=this.thisMonth.year;
    this.selectedMonth=this.thisMonth.monthNumber;
  }

  public selectDay(dayViewModel: DayItem) {
    if (dayViewModel.equivalentGregorian != null) {
      this.childPropChange.emit(dayViewModel.equivalentGregorian.toString());
    }
  }
}
